"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContextMenu_meta_1 = require("../ContextMenu.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var ClickLayer_1 = require("../../ClickLayer/ClickLayer");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(ClickLayer_1.ClickLayer, ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY, ['clickLayer']);